import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Card } from 'antd';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import { LIGHTBULB_ICON } from 'assets/icons/icons';
import { Text } from 'components/text/Text';
import { translate } from 'logic/translations/translations.service';
import Paragraph from 'antd/lib/typography/Paragraph';
import { ITranslation } from 'src/pages-all/static/tos/TOSBody';
import { ActionButton } from '../../../home/components/ActionButton';
import { enableSticky } from '../../../../components/StickySideBox/enable-sticky';
import { ReviewReferences } from 'components/promotion-certified/ReviewReferences';

const StyledWrapper = styled.div<{ padding?: string }>`
  padding: ${({ padding }) => (padding ? padding : '')};
  width: 100%;
  height: 100%;
`;

const StyledStickySideBox = styled.div`
  position: relative;
  top: 0px;
  width: 100%;
`;

const InfoCard = styled(Card)<{ width?: number; marginTop?: number }>`
  margin: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '0')} 0;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
`;

const Row = styled.div`
  margin-bottom: 14px;
`;

type props = {
  heading: string;
  paragraphsTranslationKeys: ITranslation;
  buttonText?: string;
  buttonAction?: () => void;
  width?: number;
  marginTop?: number;
  isSticky?: boolean;
  topOffset?: number;
  bottomOffset?: number;
  showTrustPilot?: boolean;
};

export const InfoBox: FC<props> = ({
  heading,
  paragraphsTranslationKeys,
  buttonText,
  buttonAction,
  width,
  marginTop,
  isSticky,
  topOffset,
  bottomOffset,
  showTrustPilot,
}) => {
  const stickySideBoxRef = useRef<HTMLDivElement>(null);
  const stickyWrapperRef = useRef<HTMLDivElement>(null);

  const stickyTopOffset = topOffset || 0;
  const stickyBottomOffset = bottomOffset || 0;

  useEffect(() => {
    if (isSticky) {
      enableSticky(stickySideBoxRef, stickyWrapperRef, stickyTopOffset, stickyBottomOffset);
    }
  }, [stickyWrapperRef, stickySideBoxRef]);

  return (
    <StyledWrapper ref={stickyWrapperRef}>
      <StyledStickySideBox ref={stickySideBoxRef}>
        <InfoCard width={width} marginTop={marginTop}>
          <Row style={{ marginBottom: '10px' }}>
            <CustomIcon height={28} src={LIGHTBULB_ICON} />
          </Row>
          <Row>
            <Text strong color="grey">
              {heading}
            </Text>
          </Row>
          {Object.entries(paragraphsTranslationKeys).map(([translationKey, translationValue]) => (
            <Paragraph key={translationKey}>
              {translate(translationValue)
                .split('\n')
                .map((line, index) => (
                  <div key={index}>
                    {line}
                    <br />
                  </div>
                ))}
            </Paragraph>
          ))}
          {buttonText && (
            <ActionButton
              style={{ width: '100%' }}
              onClick={buttonAction ? buttonAction : () => {}}
            >
              {buttonText}
            </ActionButton>
          )}
        </InfoCard>
        {showTrustPilot && (
          <InfoCard marginTop={20}>
            <ReviewReferences />
          </InfoCard>
        )}
      </StyledStickySideBox>
    </StyledWrapper>
  );
};
